import { NavBar } from '../../layout/navbar/navbar.component'
import { SideBar } from '../../layout/sidebar/sidebar.component'
import { Outlet } from 'react-router-dom'
import { PopUpDialog } from '../../components/modals/popupDialog.component'
import vr from '../../assets/images/video.mp4'
import { MobileMenu } from '../../components/mobileMenu/mobileMenu.component'
import { OpenIdeaDialog } from '../../components/modals/openIdeaDialog.component'
import { useState } from 'react'
import { useEffect } from 'react'
import { PageLoading } from '../../components/pageLoading/pageLoading.component'
import { FeedbackDialog } from '../../components/modals/feedbackDialog.component'

export const HomePage = () => {
    const [isLoaded, setIsLoaded] = useState(false)
    useEffect(() => {
        setTimeout(() => setIsLoaded(true), 400)
    })
    return (
        isLoaded ? <div>
            <div className="vertical-layout vertical-menu-modern navbar-floating footer-static menu-collapsed" data-menu="vertical-menu-modern">
                <video className='bg'
                    src={vr}
                    autoPlay
                    loop
                    playsInline
                    muted
                />
                <NavBar isSearchBar={false} isPostButton={true} isSettingButton={false} />
                <SideBar />
                <Outlet />

            </div>
            <PopUpDialog modalType={"listModal"} />
            <OpenIdeaDialog />
            <FeedbackDialog modalType={"feedbackModal"}/>
            <MobileMenu />
        </div> : <PageLoading />

    )
}